export default class TrackerScore {
    /**
     * @constructor
     * @param {string} id 
     * @param {number} score 
     * @param {number} maxScore 
     */
    constructor(id, score, maxScore) {
        this.id = id;
        this.score = score;
        this.maxScore = maxScore;
    }

    get percentage() {
        return (this.score / this.maxScore) * 100;
    }

    get fraction() {
        return this.score / this.maxScore;
    }

    getRoundedPercentage() {
        return Math.round(this.percentage);
    }
}